import { config } from '@config'
import { storage } from '@services/storageService'
import { HttpService } from '@services/HttpService'

export class DoorSettingAPIService {
  httpService = new HttpService()

  getClusterOrGroups = async (channelId, type) => {
    const url = `${config.buyingBoardServiceRestEndpoint}core/${type}/?channelId=${channelId}`
    const accessToken: string = storage.getItem('access_token')
    return await this.httpService
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(response => response?.data)
  }

  getAllotmentsByCriteria = async criteria => {
    let params = []
    Object.entries(criteria).forEach(([key, value]) => {
      params.push(`${key}=${value}`)
    })
    const url = `${
      config.buyingBoardServiceRestEndpoint
    }core/allotment/byCriteria/?${params.join('&')}`
    const accessToken: string = storage.getItem('access_token')
    return await this.httpService
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(response => response?.data)
  }

  upsertAllotment = async allotment => {
    const url = `${config.buyingBoardServiceRestEndpoint}core/allotment/upsert`
    const accessToken: string = storage.getItem('access_token')
    return await this.httpService
      .post(url, allotment, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(response => response?.data)
  }

  upsertBulkAllotment = async (allotments: any[]) => {
    const url = `${config.buyingBoardServiceRestEndpoint}core/allotment/bulk-upsert`
    const accessToken: string = storage.getItem('access_token')
    return await this.httpService
      .post(url, allotments, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(response => response?.data)
      .then(data =>
        data?.map(allot => ({
          Id: allot.id,
          Cluster: {
            Id: allot.cluster.id
          },
          ClusterGroup: {
            Id: allot.clusterGroup.id
          },
          Activity: {
            Id: allot.activity.id
          },
          Gender: {
            Id: allot.gender.id
          },
          BuyingSessionGroup: {
            Id: allot.buyingSessionGroupId
          }
        }))
      )
  }
}
